import { addStatus, removeStatus, saveOrderStatus, statusInit, updateStatusAttribute } from "features/library/reducer/LibraryActions";
import { currentWorkspaceId } from "index";
import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { findWorkspaceById } from "redux/memoizedSelectors";
import DataLoader from "shared/components/data-loader";
import DragDrop, { SetItemsProps } from "shared/Drag-Drop/DragDrop";
import { CustomizationColors } from "shared/ui-basics";
import { CustomBreadCrumb } from "shared/ui-basics/ui-components/CustomBreadCrumb";
import { CxValidation, encode, getRandomInt } from "utils/helpers";
import TaxonomyCreateItem from "../components/TaxonomyCreateItem";
import TaxonomyListItem from "../components/TaxonomyListItem";
import { Body, Container, Header, RecordsContainer, Wrapper } from "./style";

const TaxonomyStatus: React.FC = () => {
	const { t } = useTranslation();

	const currentWorkspace = useSelector(findWorkspaceById(currentWorkspaceId));
	const statuses = useSelector((state: any) => state.libraries.status);
	const isStandard = useSelector((state: any) => state.auth?.userInfo?.UserSubscriptionPlanName) === "Standard";
	const colors = Object.keys(CustomizationColors);

	const [tabKey, setTabKey] = useState("customerJourney");

	const handleChangeTab = (k: string) => setTabKey(k);

	const onCreate = ({ name }: { name: string }) =>
		addStatus({ newStatus: { name: encode(name?.truncate(100, true)), colorCode: colors[getRandomInt(0, colors.length - 1)], CXEntity: CxValidation(tabKey) }, type: tabKey });

	const onUpdate = ({ updatedItem, modifiedAttribNames }: { updatedItem: any; modifiedAttribNames: string[] }) =>
		updateStatusAttribute({ modifiedStatus: updatedItem, modifiedAttribNames, type: tabKey });

	const onDelete = ({ item }: { item: any }) => removeStatus({ id: item.id, type: tabKey });

	const onDragEnd = ({ newItems }: SetItemsProps) => saveOrderStatus({ ids: newItems?.map((el) => el.id)?.join("|"), params: tabKey });

	const tabs = [
		{ key: "customerJourney", title: t("JOURNEYS") },
		{ key: "insight", title: t("ASPX_33") },
		{ key: "opportunity", title: t("OPPORTUNITIES") },
		{ key: "solutions", title: t("SOLUTIONS") },
		{ key: "cxActions", title: t("ACTION_ITEM") },
		{ key: "project", title: t("PROJECTS") },
	].filter((tab) => (isStandard ? tab.key === "customerJourney" : true));

	return (
		<DataLoader asyncFns={[{ asyncFn: statusInit, parameter: { showUsedData: true } }]}>
			<Container>
				<Header>
					<CustomBreadCrumb paths={[currentWorkspace?.name, t("TAXONOMY"), t("ASPX_222")]} />
				</Header>
				<Body>
					<Wrapper>
						<div className="f24-title mb-4">{t("ASPX_222")}</div>
						<Tabs activeKey={tabKey} onSelect={handleChangeTab} unmountOnExit={true}>
							{tabs.map((tab) => (
								<Tab key={tab?.key} eventKey={tab?.key} title={tab?.title} />
							))}
						</Tabs>
						<TaxonomyCreateItem onCreate={onCreate} tabKey={tabKey} />
						<RecordsContainer>
							<DragDrop items={statuses?.[tabKey]} setItems={onDragEnd} orientation="vertical">
								{(item) => <TaxonomyListItem key={item.id} item={item} onUpdate={onUpdate} onDelete={onDelete} showDot={true} />}
							</DragDrop>
						</RecordsContainer>
					</Wrapper>
				</Body>
			</Container>
		</DataLoader>
	);
};

export default TaxonomyStatus;
